<template>
  <!-- Fallback when no stream is provided -->
  <div v-show="!stream" class="relative w-full h-full bg-gray-800">
    <div class="flex items-center justify-center w-full h-full">
      <span class="border h-16 w-16 rounded-full flex items-center justify-center text-white text-2xl">
        <i :class="'feather-video-off'"></i>
      </span>
    </div>
  </div>

  <!-- Video container when stream is available -->
  <div v-show="stream" class="relative w-full h-full">
    <video
      :id="id"
      ref="video"
      autoplay
      playsinline
      class="w-full h-full object-cover"
      :muted="muted"
      style="object-fit: cover;"
    ></video>
  </div>
</template>

<script>

export default {
  name: 'VideoPreview',

  props: {
    id: {
      type: String,
      required: true,
    },

    stream: {
      type: Object,
      default: null,
    },
    hasVideo: {
      type: Boolean,
      default: false,
    },
    hasAudio: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    stream: {
      handler(newStream) {
        console.log('VideoPreview-stream', newStream, this.stream, document.querySelector(`#${this.id}`))
        if (document.querySelector(`#${this.id}`)) {
          document.querySelector(`#${this.id}`).srcObject = newStream;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // Set the video element's srcObject when the component mounts
    if (this.$refs.video && this.stream) {
      this.$refs.video.srcObject = this.stream;
    }
  },
};
</script>

<style scoped>
/* Add any component-specific styles here if needed */
</style>
